import React from 'react';
import styles from './Contact.module.css';
const cover = process.env.PUBLIC_URL + '/images/cover.JPG';

const Contact = () => {
  const contactMethods = [
    {
      icon: "📧",
      method: "Email",
      value: "obentech@gmail.com",
      link: "mailto:obentech@gmail.com"
    },
    {
      icon: "📱",
      method: "WhatsApp",
      value: "+2348139189213",
      link: "https://wa.me/2348139189213"
    },
    {
      icon: "💼",
      method: "LinkedIn",
      value: "Connect on LinkedIn",
      link: "https://www.linkedin.com/in/emmanuel-oben"
    },
    {
      icon: "🔒",
      method: "Secure Contact",
      value: "PGP Key Available",
      link: "#"
    }
  ];

  return (
    <div className={styles.container} id="contact">
      <h1 className={styles.title}>Contact</h1>
      <div className={styles.coverContainer}>
        <img src={cover} alt="Contact Cover" className={styles.coverImg} />
        <div className={styles.overlay}>
          <h2>Let's Secure Your Digital Future</h2>
          <p>Available for consultations and security assessments</p>
        </div>
      </div>
      
      <div className={styles.content}>
        <p className={styles.intro}>
          Ready to enhance your cybersecurity posture? Get in touch with me through any of the following methods:
        </p>
        
        <div className={styles.contactGrid}>
          {contactMethods.map((method, index) => (
            <a 
              key={index}
              href={method.link}
              className={styles.contactCard}
              target={method.link.startsWith('http') ? '_blank' : '_self'}
              rel={method.link.startsWith('http') ? 'noopener noreferrer' : ''}
            >
              <span className={styles.icon}>{method.icon}</span>
              <h3>{method.method}</h3>
              <p>{method.value}</p>
            </a>
          ))}
        </div>

        <div className={styles.availability}>
          <h3>Availability</h3>
          <p>
            I'm available for both short-term security assessments and long-term consulting engagements.
            Response time: Within 24 hours
          </p>
        </div>

        <div className={styles.note}>
          <p>
            For sensitive communications, please use my PGP key or request a secure communication channel.
            Your security and privacy are my top priorities.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;
